/**
 * Created by mac on 2018/8/25.
 */
import React, { Component, Fragment } from 'react';
import i18n from 'react-intl-universal';
import styles from './step.scss';
import IconFont from '../Icon/IconFont';

export default class StepOne extends Component {
  goUrl(channel) {
    const { token, id } = this.props;
    const url = window.location.href;
    console.log('steponeUrl', `/users/auth/${channel}?bind_token=${token}&target_user_id=${id}&redirect_url=${encodeURIComponent(url)}`);
    window.location.href = `/users/auth/${channel}?bind_token=${token}&target_user_id=${id}&redirect_url=${encodeURIComponent(url)}`;
  }
  render() {
    const { username, token, id } = this.props;
    return (
      <div className={styles.container}>
        <div className={styles.title}>
          <div className={styles.index}>1</div>
          <p>为账号「{username}」{i18n.get('bind.bindway')}</p>
        </div>
        <div className={styles.ways}>
          <p>
            <IconFont name="weibo" className={styles.webo}/>
            <span
              className={styles.channel}
              onClick={() => { this.goUrl('weibo'); }}
            >{i18n.get('bind.bindwb')}<IconFont name="youjiantou1"/>
            </span>
          </p>
          <p>
            <IconFont name="qq" className={styles.qq}/>
            <span
              className={styles.channel}
              onClick={() => { this.goUrl('qq_connect'); }}
            >{i18n.get('bind.bindqq')}<IconFont name="youjiantou1"/>
            </span>
          </p>
          <p>
            <IconFont name="douban" className={styles.douban}/>
            <span
              className={styles.channel}
              onClick={() => { this.goUrl('douban'); }}
            >{i18n.get('bind.binddb')}<IconFont name="youjiantou1"/>
            </span>
          </p>
        </div>
      </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/HasBindMordal/StepOne.js